

















































import {mapActions, mapGetters} from 'vuex';
import {JWTBody, MyProfileAPI} from '#/User';
import {emptyProfile} from '@/store/modules/Profile/state';
import {TranslateResult} from 'vue-i18n';
import vue from 'vue';

interface DataComponent {
  dialog: {
    content: TranslateResult;
    display: boolean;
    title: TranslateResult;
  };
  JWTBody: null | JWTBody;
  user: MyProfileAPI;
}

export default vue.extend({
  name: 'FirstConnection',

  data: (): DataComponent => ({
    dialog: {
      content: '',
      display: false,
      title: '',
    },
    JWTBody: null,
    user: emptyProfile(),
  }),

  computed: {
    ...mapGetters([
      'profile',
      'username',
    ]),
    buttonDisabled(): boolean {
      return !this.user.termsAccepted || !this.user.gdprAccepted;
    },
    isUDS(): boolean {
      return this.JWTBody !== null && process.env.VUE_APP_ACTIVE_SYNC_ACTION
          ? this.JWTBody.organization === 'UDS' && process.env.VUE_APP_ACTIVE_SYNC_ACTION === 'true'
          : false;
    },
  },

  mounted() {
    this.profile.username === ''
        ? this.loadProfile()
              .then(() => {
                this.user = Object.assign({}, this.profile);
                this.user.username = this.username;
              })
        : this.user = Object.assign({}, this.profile);

    this.user.username = this.username;

    if (localStorage.getItem('JWT__access__token')) {
      this.JWTBody = JSON.parse(
          window.atob((localStorage.getItem('JWT__access__token') as string).split('.')[1]),
      );
    }
  },

  methods: {
    ...mapActions([
      'createProfile',
      'loadProfile',
    ]),
    onOpenDialog(name: string): void {
      this.dialog.content = this.$t(`profile.firstConnection.modal.${name}.text`);
      this.dialog.title = this.$t(`profile.firstConnection.modal.${name}.title`);
      this.dialog.display = true;
    },
    stringToHslColor(str: string, s: number, l: number): string {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const h = hash % 360;
      return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    },
    validProfile(): void {
      this.user.profileColor = this.stringToHslColor(this.user.username, 65, 65);
      this.createProfile(this.user);
    },
  },
});
